export default "__VITE_ASSET__B_510pad__"